import {FlexibleStyleProp} from 'common/theme/theme.types';

type ButtonBaseStyles = {
    fontSize?: FlexibleStyleProp;
    [key: string]: FlexibleStyleProp | undefined;
};

export const baseStyles: ButtonBaseStyles = {
    fontSize: 'sm',
};
